import React from 'react';

import { Container } from './Backdrop.styles';

export interface BackdropProps {
  /**
   * Children nodes
   */
  children: React.ReactNode;
  /**
   * Click event handler
   */
  onClick?: () => void;
}

const Backdrop = ({ children, onClick }: BackdropProps) => (
  <Container
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    onClick={onClick}
  >
    {children}
  </Container>
);

export default Backdrop;
